import { useEffect, useState } from 'react';

import { Box, Button, Grid, Pagination, Typography } from '@mui/material';

import { Timestamp } from '@bufbuild/protobuf';
import {
  AssessInfoCard,
  AssessmentTopicPopup,
  ClickerPoupSingleButton,
  EarlyHomeworkPopup,
  FilterSortPopup,
  IStyles,
  ImageWrapper,
  InfoDisplayCard,
  NoContentCard,
  ShimmerManageHwCard,
  StudentSubjectPopup,
  deserify,
  formatDateAsDayMonth,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  remainingTimeInHoursAndMins,
  SearchBar,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import {
  AssessmentEnum,
  AssignmentConfigEnum,
  ModeOfConductionEnum,
  TaskStudentAttemptStatusEnum,
} from '@protos/learning_management/lms.db_pb';
import { StudentHomeworkTask } from '@protos/learning_management/lms.hw.student.apis_pb';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  Active_Project_Details,
  HOME,
  project_Start_Cover,
  Student_Gil_Journey,
} from '../../../routeHandling/RoutesNomenclature';
import { onHomeworkCardClick } from '../../../utils/homework';
import { interactionEvent } from '../../Auth/Login/login_logout.events';
import { setHomeSelectedSubjectId } from '../../Home/reducer/homeDashboard.slice';
import {
  AssessmentListEnum,
  StudentAssessmentTask,
} from '@protos/learning_management/lms.assessment.student.apis_pb';
import { getSubjectList } from 'apps/student/src/utils/commonUtils';
import { useFilteredLearnSubjects } from '../../../utils/ssoUserHooks';
import { TabComp } from '../../Homework/StudentHwDash/component/TabComp';
import { HwDashSubjectFilter } from '../../Homework/StudentHwDash/component/HwDashSubjectFilter';
import { useDownloadContext } from 'apps/student/src/app/Context/DownloadContextProviderV2';
import {
  setActiveHomeworkList,
  setAssignedData,
  setEndedData,
  setEndedHomeworkList,
  setHwInfoData,
  setProjectEndPath,
} from '../reducer/labaroatory.slice';
import ProjectDashboardBanner from '../components/ProjectDashboardBanner';
import StudentProjectCardWithGroup from '../../../components/StudentProjectCardWithGroup';

const styles: IStyles = {
  root: {
    boxSizing: 'border-box',
    pb: { xs: pxToRem(30), md: pxToRem(36), lg: pxTovW(50) },
    // backgroundColor: 'red',
  },

  mainHeadingBox: {
    p: { md: pxToRem(20), lg: `${pxTovW(27)} ${pxTovW(241)} 0 ${pxTovW(241)}` },

    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(21), md: pxToRem(27), lg: pxTovW(34.5) },
  },

  hwMapper: {
    boxSizing: 'border-box',
    p: {
      xs: `${pxToRem(25)} ${pxToRem(20)}`,
      md: `${pxTovW(40)} ${pxTovW(200)}`,
      lg: `${pxTovW(39)} ${pxTovW(239)}`,
    },

    idcStyle: {
      border: '1px solid red',
      width: { xs: pxToRem(319), md: pxTovW(347) },
      height: { xs: pxToRem(160), md: pxToRem(98), lg: pxTovW(153) },
    },
    margin: 'auto',
    width: { xs: '100%', md: 'auto' },
  },
  title: {
    paddingTop: { xs: pxToRem(15), md: 0 },
    paddingLeft: { xs: pxToRem(15), md: 0 },
    // backgroundColor: 'red',
  },
  imageBox: {
    width: { xs: '100%', md: '100%', lg: pxTovW(245) },
    height: { xs: '100%', md: '100%', lg: pxTovW(233) },
    objectFit: 'cover',
    // backgroundColor: '#E0DFDE',
  },
  image: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: { xs: pxToRem(16), md: pxToRem(16), lg: pxTovW(16) },
  },
  // Green report pill, as used for report CTAs across the apps.
  reportsButtonBox: {
    display: 'flex',
    justifyContent: { xs: 'stretch', md: 'flex-end' },
    paddingTop: { xs: pxToRem(16), md: pxToRem(18), lg: pxTovW(20) },
  },
  reportsButton: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(6), md: pxToRem(10), lg: pxTovW(10) },
    width: { xs: '100%', md: 'max-content' },
    height: { xs: pxToRem(45), md: 'auto' },
    minHeight: { md: pxToRem(40), lg: pxTovW(56) },
    paddingX: { xs: pxToRem(20), md: pxToRem(21), lg: pxTovW(24) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(15), lg: pxTovW(15) },
    backgroundColor: '#158D29',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': { backgroundColor: '#127A23' },
  },
  filterRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'center',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(24) },
    mt: { xs: pxToRem(15), md: pxTovW(39) },
    px: { xs: pxToRem(20), md: 0 },
  },
  // HwDashSubjectFilter also renders the assessment-type dropdown and its own
  // sort; keep only its first child (the subject picker) on this page.
  subjectFilter: {
    width: { xs: '100%', md: 'auto' },
    '& > div': { mt: 0, px: 0 },
    '& > div > :not(:first-of-type)': { display: 'none' },
  },
  searchBox: {
    width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
    marginY: { md: 'auto' },
  },
  sortBox: {
    marginY: { md: 'auto' },
    marginX: { xs: 'auto', md: 0 },
  },
  reportsButtonIcon: {
    width: { xs: pxToRem(20), md: pxToRem(22), lg: pxTovW(26) },
    height: { xs: pxToRem(20), md: pxToRem(22), lg: pxTovW(26) },
    objectFit: 'contain',
  },
};
const SORT_OPTIONS = [
  'Name: A to Z',
  'Name: Z to A',
  'Newest First',
  'Oldest First',
  'Deadline',
];

const toMillis = (ts?: { seconds?: bigint | number }) =>
  ts?.seconds !== undefined ? Number(ts.seconds) * 1000 : 0;

const sortProjects = (list: StudentAssessmentTask[], sortBy: string) => {
  const sorted = [...list];
  switch (sortBy) {
    case 'Name: A to Z':
      return sorted.sort((a, b) =>
        (a.assessmentTitle ?? '').localeCompare(b.assessmentTitle ?? '')
      );
    case 'Name: Z to A':
      return sorted.sort((a, b) =>
        (b.assessmentTitle ?? '').localeCompare(a.assessmentTitle ?? '')
      );
    case 'Newest First':
      return sorted.sort(
        (a, b) => toMillis(b.startDate) - toMillis(a.startDate)
      );
    case 'Oldest First':
      return sorted.sort(
        (a, b) => toMillis(a.startDate) - toMillis(b.startDate)
      );
    case 'Deadline':
      return sorted.sort((a, b) => toMillis(a.endDate) - toMillis(b.endDate));
    default:
      return list;
  }
};

export const ManageStudentProjectDash = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedAssessment, setSelectedAssessment] = useState<
    StudentAssessmentTask | undefined
  >();
  const [chapterListPopup, setChapterListPopup] = useState(false);
  const { setSelectedFunction } = useGlobalContext();
  const { isOffline } = useDownloadContext();

  const { userInfo } = deserify(useAppSelector((state) => state.auth));

  const studentId = deserify(
    useAppSelector((state) => state.auth.userInfo?.studentProfileId)
  );
  const {
    assigned_homework,
    ended_homework,
    hw_info,
    active_homework_content,
    selected_homework_data,
  } = deserify(useAppSelector((state) => state.laboratory));
  const activeHomeworkContent =
    active_homework_content && selected_homework_data?.homeworkId
      ? active_homework_content[selected_homework_data?.homeworkId]
      : undefined;

  const learnSubjects =
    deserify(useAppSelector((state) => state.auth.userInfo?.learnSubjects)) ||
    [];
  const filteredLearnSubjects = useFilteredLearnSubjects();

  const { selected_subject_id } = deserify(
    useAppSelector((state) => state.home)
  );
  const { isIpadOnly } = useGlobalContext();
  const mapData = ['Active', 'Ended'];
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );
  const [startTime, setStartTime] = useState<Timestamp | undefined>(undefined);
  const [assessmentTypeEnum, setAssessmentTypeEnum] = useState<
    AssessmentEnum | undefined
  >(undefined);
  const [modalState, setModalState] = useState(false);
  // The home page's "See All" says which section it came from.
  const [value, setValue] = useState(
    mapData.includes(location.state?.assessmentState)
      ? location.state.assessmentState
      : mapData[0]
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [sortBy, setSortBy] = useState('');
  const { LmsAssessmentStudentApiServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();
  const [classroomAssessmentPopup, setClassroomAssessmentPopup] = useState<{
    iconName: string;
    popupTextLines: string[];
  } | null>(null);
  const handleChange = async (newValue: string) => {
    setValue(newValue);
    setPageNumber(1);
    await interactionEvent({
      url: 'Student_Homework_dash',
      context: 'your_assessment',
      name: newValue.toUpperCase(),
      isOffline: isOffline,
    });
  };
  // const subMap = getSubjectsMap(learnSubjects);

  useEffect(() => {
    const redirectToHome = () => {
      navigate(HOME);
    };
    setSelectedFunction(() => redirectToHome);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  useEffect(() => {
    getStudentHomeworkList();
  }, [pageNumber, value, selected_subject_id]);

  const getStudentHomeworkList = async () => {
    try {
      // setLoading('loading');

      if (
        (value === 'Active' &&
          assigned_homework &&
          !assigned_homework[pageNumber]) ||
        (value === 'Ended' && ended_homework && !ended_homework[pageNumber])
      ) {
        setLoading('loading');
      } else {
        setLoading('completed');
      }

      const response =
        await LmsAssessmentStudentApiServiceV1ClientWithStatusCodeHandler.getStudentAssessmentList(
          {
            studentId: studentId,
            pageNumber: pageNumber,
            subjectId: selected_subject_id,
            assessmentType: AssessmentEnum?.ASSESSMENT_PROJECT,
            assessmentListType:
              value === 'Active'
                ? AssessmentListEnum.ASSESSMENT_ACTIVE
                : AssessmentListEnum.ASSESSMENT_ENDED,
          }
        );

      const countInPagination =
        response.data?.assessmentListInfo?.countInPagination;

      dispatch(setActiveHomeworkList(response.data?.allAssessment?.active));
      dispatch(setEndedHomeworkList(response.data?.allAssessment?.ended));

      dispatch(
        setAssignedData({
          ...assigned_homework,
          [pageNumber]: response.data?.allAssessment?.active,
        })
      );
      dispatch(
        setEndedData({
          ...ended_homework,
          [pageNumber]: response.data?.allAssessment?.ended,
        })
      );

      dispatch(
        setHwInfoData({
          ...hw_info,
          hwListInfo: response.data?.assessmentListInfo,
          totalAssignedPages: Math.ceil(
            (response.data?.assessmentListInfo?.activeAssessmentCount || 0) /
              (countInPagination || 1)
          ),
          totalEndedPages: Math.ceil(
            (response.data?.assessmentListInfo?.endedAssessmentCount || 0) /
              (countInPagination || 1)
          ),
        })
      );

      setLoading('completed');
    } catch (err) {
      console.log(err);
      setLoading('error');
      dispatch(setActiveHomeworkList([]));
      dispatch(setEndedHomeworkList([]));
    }
  };

  const ChapterListPopupHandler = (assessment: StudentAssessmentTask) => {
    setSelectedAssessment(assessment);
    setChapterListPopup(true);
  };

  const showPagination = () => {
    return (
      (value === 'Active' && hw_info && hw_info.totalAssignedPages > 0) ||
      (value === 'Ended' && hw_info && hw_info.totalEndedPages > 0)
    );
  };
  const renderHomeworkList = (
    homeworkList: StudentAssessmentTask[] | undefined
  ) => {
    const isEnded = value === 'Ended';
    const query = searchText.trim().toLowerCase();
    const visibleList = sortProjects(
      (homeworkList ?? []).filter(
        (project) =>
          !query || project.assessmentTitle?.toLowerCase().includes(query)
      ),
      sortBy
    );
    if (query && visibleList.length === 0) {
      return (
        <Typography variant="h4" sx={{ width: '100%', textAlign: 'center' }}>
          No projects found for "{searchText.trim()}"
        </Typography>
      );
    }
    return visibleList.map((val, index) => (
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        key={String(val?.assessmentId ?? index)}
      >
        <StudentProjectCardWithGroup
          project={val}
          isEnded={isEnded}
          rootStyles={{ maxWidth: '100%' }}
          onClick={() => {
            if (location?.pathname) {
              dispatch(setProjectEndPath(location?.pathname));
            }

            // Ended or already-submitted projects have nothing left to
            // "start", so skip the start-cover screen and go straight to
            // the details view.
            const isSubmitted =
              val?.studentAttemptStatus ===
              TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED;
            navigate(
              isEnded || isSubmitted
                ? `${Active_Project_Details}?assessmentId=${val?.assessmentId}`
                : `${project_Start_Cover}?assessmentId=${val?.assessmentId}`
            );
          }}
        />
      </Grid>
    ));
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.mainHeadingBox}>
        <Box
          sx={{
            paddingLeft: { xs: pxToRem(20), lg: 0 },
            paddingTop: { xs: pxToRem(20), lg: 0 },
            paddingRight: { xs: pxToRem(20), lg: 0 },
            boxSizing: 'border-box',
          }}
        >
          <ProjectDashboardBanner />

          <Box sx={styles.reportsButtonBox}>
            <Button
              sx={styles.reportsButton}
              onClick={() => navigate(Student_Gil_Journey)}
            >
              <ImageWrapper
                name="reports"
                type="png"
                parentFolder="icons"
                styles={styles.reportsButtonIcon}
              />
              <Typography variant="h4" fontWeight="bold" color="common.white">
                My GIL Journey
              </Typography>
            </Button>
          </Box>
        </Box>

        <TabComp
          handleChange={handleChange}
          mapData={mapData}
          stateValue={value}
          // count={filteredHomeworkList.length}
          count={
            value === 'Active'
              ? hw_info?.hwListInfo?.activeAssessmentCount || 0
              : value === 'Ended'
              ? hw_info?.hwListInfo?.endedAssessmentCount || 0
              : 0
          }
        />
      </Box>

      <Box sx={styles.filterRow}>
        <Box sx={styles.subjectFilter}>
          <HwDashSubjectFilter
            setModalState={setModalState}
            filterFunction={() => undefined}
            sortFunction={() => undefined}
            tab={value}
          />
        </Box>

        <Box sx={styles.searchBox}>
          <SearchBar
            searchText={searchText}
            handleSearchTextChange={setSearchText}
            handleSearch={(text) => setSearchText(text ?? '')}
            handleClose={() => setSearchText('')}
          />
        </Box>
        <Box sx={styles.sortBox}>
          <FilterSortPopup
            iconName="Sort"
            title="Sort By"
            options={SORT_OPTIONS}
            sortFunction={setSortBy}
          />
        </Box>
      </Box>

      {loading === 'loading' ? (
        // <Loader />
        <ShimmerComponent />
      ) : loading === 'error' ? (
        <NoContentCard variant="error" icon="error" text="Error Occured" />
      ) : (
        <Box sx={styles.hwMapper}>
          <Grid container rowGap={3}>
            {renderHomeworkList(
              value === 'Active' && assigned_homework
                ? assigned_homework[pageNumber]
                : value === 'Ended' && ended_homework
                ? ended_homework[pageNumber]
                : []
            )}
          </Grid>
        </Box>
      )}

      {showPagination() ? (
        <Pagination
          page={pageNumber}
          // count={10}
          count={
            value === 'Active'
              ? hw_info?.totalAssignedPages
              : value === 'Ended'
              ? hw_info?.totalEndedPages
              : 0
          }
          color="primary"
          onChange={async (event: React.ChangeEvent<unknown>, page: number) => {
            setPageNumber(page);
            if (pageNumber !== page) {
              await interactionEvent({
                url: 'Student_homework_dash',
                context: 'navigation_bar',
                name: 'PAGE_CHANGE',
                isOffline: isOffline,
              });
            }
          }}
          sx={{ width: 'max-content', margin: 'auto' }}
        />
      ) : (
        <Box sx={{ width: 'max-content', margin: 'auto' }}>
          <Typography variant="h2" fontWeight="bold" margin="auto">
            No {value} Projects
          </Typography>
        </Box>
      )}

      <StudentSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={filteredLearnSubjects.map((sub) => ({
          subject: sub.subjectName,
          icon: getMediaBasePath(sub.iconUrl, 'schoolnetStaticAssetBucket'),
          color: sub.textColor,
          onClick: async () => {
            await interactionEvent({
              url: 'Student_Learn_dashboard',
              context: 'subject_selection',
              name: sub.subjectName.toUpperCase().replace(/ /g, '_'),
              isOffline: isOffline,
            });
            dispatch(setHomeSelectedSubjectId(sub.subjectId));
            setModalState(false);
            setPageNumber(1);
          },
        }))}
        title="Choose Subject"
      />

      <EarlyHomeworkPopup
        open={!!startTime}
        assessmentType={assessmentTypeEnum}
        okHandler={() => {
          setStartTime(undefined);
          setAssessmentTypeEnum(undefined);
        }}
        startTime={startTime}
      />

      <AssessmentTopicPopup
        assessment={selectedAssessment}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
        subjectsAvailable={getSubjectList(userInfo?.learnSubjects)}
      />
    </Box>
  );
};

const ShimmerComponent = () => {
  return (
    <Grid
      container
      rowGap={3}
      sx={{
        boxSizing: 'border-box',
        width: { md: pxTovW(1100) },
        margin: 'auto',
        p: { xs: pxToRem(20), md: pxToRem(0), lg: pxTovW(0) },
      }}
    >
      {Array.from({ length: 12 }, (_, index) => (
        <Grid item xs={11} md={4} key={index}>
          <ShimmerManageHwCard key={index} />
        </Grid>
      ))}
    </Grid>
  );
};
